module.exports = __webpack_public_path__ + "static/media/SSDorris.9550cf41.png";